import * as THREE from "three"

//const glsl = (x) => x

const CustomShader = {
  uniforms: {
    effectFactor: { type: "f", value: 1.2 },
    dispFactor: { type: "f", value: 0 },
    texture: { type: "t", value: undefined },
    texture2: { type: "t", value: undefined },
    disp: { type: "t", value: undefined },
    windowWidth: { type: "f", value: 3200 },
    windowHeight: { type: "f", value: 900 },

    diffuseMaterial: { type: "c", value: new THREE.Color(1, 0, 0) },
    specularMaterial: { type: "c", value: new THREE.Color(0.7, 0.7, 0.7) },
    ambientMaterial: { type: "c", value: new THREE.Color(0.8, 0.2, 0.2) },
    shininessMaterial: { type: "f", value: 16.0 }
  },
  vertexShader: `
    varying vec2 vUv;
    
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
  `,
  fragmentShader: `
    precision mediump float;
    varying vec2 vUv;
    uniform float _rot;
    uniform float effectFactor;
    uniform float dispFactor;
    uniform float windowWidth;
    uniform float windowHeight;

    float random (in vec2 st) {
        return fract(sin(dot(st.xy,
                            vec2(12.9898,78.233)))
                    * 43758.5453123);
    }

    float noise(vec2 st) {
        vec2 i = floor(st);
        vec2 f = fract(st);
        vec2 u = f*f*(3.0-2.0*f);
        return mix( mix( random( i + vec2(0.0,0.0) ),
                        random( i + vec2(1.0,0.0) ), u.x),
                    mix( random( i + vec2(0.0,1.0) ),
                        random( i + vec2(1.0,1.0) ), u.x), u.y);
    }
    
    mat2 rotate2d(float angle){
        return mat2(cos(angle),-sin(angle),
                    sin(angle),cos(angle));
    }
    
    float lines(in vec2 pos, float b){
        float scale = 10.0;
        pos *= scale;
        return smoothstep(0.0,
                        .5+b*.5,
                        abs((sin(pos.x*3.1415)+b*2.0))*.5);
    }
    
    void main() {
        vec2 uv = vUv;
        vec2 st = gl_FragCoord.xy/vec2(2000.0 +  windowHeight/ windowWidth * 5.0, 2000.0 * windowHeight / windowWidth * effectFactor);
        st.y *= 200.0 / 3200.0;
    
        vec2 pos = st.yx * vec2(10.0 + uv.x * dispFactor, 10.0 + uv.y * dispFactor);
    
        float pattern = pos.x;
    
        // Add noise
        pos = rotate2d( noise(pos ) ) * pos;
    
        // Draw lines
        pattern = lines(pos,.5 * _rot);

        vec4 texture = vec4(vec3(pattern),1.0);

        //vec2 distortedPosition = vec2(uv.x, );
        //vec4 _texture = texture2D(texture, distortedPosition);
    
        gl_FragColor = texture;
    }
  `
}

export { CustomShader }
